<template>
  <container :class="['elevation']">
    <elevation-swatches @input="copyToClipboard($event)" :elevations="elevations" :title="$lang.positiveElevation" />
    <elevation-swatches negative @input="copyToClipboard($event)" :elevations="elevations" :title="$lang.negativeElevation" />
    <snackbar v-model="snackbar" :bg-color="$root.colors.primary" :bg-color-lightness="$root.colors.bgColorLightness">{{ $lang.copiedToClipboard(copiedValue) }}</snackbar>
  </container>
</template>
<script>
import methods from '../mixins/methods'
import ElevationSwatches from './elevation-swatches'

export default {
  name: 'Elevation',
  components: {
    ElevationSwatches
  },
  mixins: [
    methods
  ],
  data () {
    return {
      elevations: [],
      snackbar: false,
      copiedValue: null
    }
  },
  mounted () {
    this.getExternalData('elevations.json', 'elevations')
  }
}
</script>



// WEBPACK FOOTER //
// src/components/elevation.vue